import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { isEmpty, isNull, isUndefined } from 'lodash';
import * as S from './style'

import { alturaVolume, t } from '~/helpers';
import { Spinner } from '~/components';
import { Input, Select, InputText } from '~/components/Form';
import { parseISO, format } from 'date-fns';
import {
  updateLimiteAbastecimento,
  findLimiteAbastecimento
} from '~/store/modules/limiteAbastecimento/actions';

export default function CreateOrUpdate({ data, ...props }) {
  const dispatch = useDispatch();

  const reference = useRef(null)

  const [initials, setInitials] = useState({})

  const { client } = useSelector((state) => state.user.profile);
  const { find, params } = useSelector((state) => state.limiteAbastecimento);
  const [loading, setLoading] = useState(true)



  useEffect(() => {
    if (isEmpty(find) && !isEmpty(data)) {
      dispatch(findLimiteAbastecimento(data.clab_codigo))
    } else if (!isEmpty(find) && !isEmpty(data)) {
      setInitials({ ...find, ...data, })
      setLoading(false)
    }

  }, [find, data])

  const optionsStatus = useMemo(
    () => [
      { value: 'A', label: 'Ativo' },
      { value: 'D', label: 'Desativado' },
    ],
    []
  );

  const optionsTipo = useMemo(
    () => [
      { value: 'V', label: 'Volume' },
      { value: 'P', label: 'Percentual' },
    ],
    []
  );

  const handleTestVolume = useCallback((value, tipo) => {
    let test
    if (tipo == 'P') {
      test = Number(value) <= 100 && Number(value) >= 0 ? true : false
    } else {
      test = Number(value) <= 600 && Number(value) >= 0 ? true : false
    }

    return test

  }, [])

  const handleSetValue = useCallback((field, value) => {
    reference.current.setFieldValue(field, value);
  }, []);

  async function handleSubmit(param) {
    try {


      const schema = Yup.object().shape({
        clab_status: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        clab_tipo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        clab_cota:
          Yup.string().required(
            t('s.geral.validacao.campoobrigatorio'))
            .test('teste de valor', 'Volume incorreto', (value) => handleTestVolume(value, param.clab_tipo)),

      });


      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...param,
        clab_cota: Number(param.clab_cota),
      };
      delete objSend.clab_datahora_atu

      await dispatch(updateLimiteAbastecimento(objSend, params));
      props.close();

    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (props.sending) {
      reference.current.submitForm()
    }
  }, [props.sending,]);



  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <S.FormWrapper ref={reference} initialData={{
          ...initials,
          clab_datahora_atu: format(parseISO(initials.clab_datahora_atu), 'dd/MM/yyyy HH:mm'),
          clab_cota: Number(initials.clab_cota).toString()
        }} onSubmit={handleSubmit}>

          <Input name="clab_codigo" label="Código: " disabled />
          <Input name="usua_login_atu" label="Usuário:" disabled />
          <Input name="clab_datahora_atu" label="Horário:" disabled />

          <Select
            name="clab_status"
            label="Status:"
            options={optionsStatus}
          />

          <Select
            name="clab_tipo"
            label="Tipo:"
            options={optionsTipo}
          />

          <InputText
            name="clab_cota"
            mask="9999999"
            label="Cota:"
            placeholder=''
          />

          <Input
            name="clab_observacao_atu"
            label="Observação:"
            multiline
            inputProps={{ maxLength: 300 }}
            rows={4}
          />

        </S.FormWrapper>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
